module.exports = __webpack_public_path__ + "img/recognition_img.23c6d3bd.png";